<template>
  <avs-chip
    class="min-width-120"
    color="error"
    icon="mdi-close-circle"
    iconColor="white"
    text-color="white"
  >
    {{ $t("Refusée") }}
  </avs-chip>
</template>

<script>
export default {
  name: "RejectedChip",
};
</script>

<style scoped>
.min-width-120 {
  min-width: 120px;
}
</style>